import React from 'react';
import "./failure.css";
import Button from '../../../Elements/Button/Button';
import { useNavigate } from 'react-router-dom';

const Failure = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate("/"); // Redirige al inicio
    };

    return (
        <div className="container-fluid failure-container d-flex justify-content-center align-items-center">
            <div className="failure-card text-center">
                <div className="failure-icon">✕</div>
                <h1 className="failure-title">Pago Fallido</h1>
                <p className="failure-message">
                    Ocurrió un error al procesar tu transacción. ❌
                    Por favor intenta de nuevo.
                </p>

                {/* Botón reutilizable */}
                <Button
                    text="Volver al inicio"
                    action={handleGoHome}
                    color="purple"
                    fill={true}
                    classNames="mt-3"
                />
            </div>
        </div>
    )
}

export default Failure;